import React, { useState } from 'react'
import { Redirect } from 'react-router-dom'
import classnames from 'classnames'
import { Button } from '@deal/components'
import useBreakpoint from '#src/hooks/useBreakpoint'
import { generateCreateUrlFromCategory } from '#src/services/path'
import CategorySelectorSheet from '#src/components/CategorySelectorSheet'
import DownArrow from './down-arrow.svg'
import styles from './styles.css'

interface DropdownNavigationItem {
  redirectLocation: string
  displayName: string
}

interface Props {
  sourceKey?: string
  light?: boolean
  dropdownPlaceholder?: string
  buttonText?: string
}

const PathDropdown: React.SFC<Props> = ({
  light,
  sourceKey = 'category-sheet-selector',
  dropdownPlaceholder = "I'm looking for...",
  buttonText = "Let's find it together"
}) => {
  const [categorySelectorExpanded, setCategorySelectorExpanded] = useState(false)
  const [dropdownNavigationItem, setDropdownNavigationItem] = useState<
    DropdownNavigationItem | undefined
  >()
  const [redirectLocation, setRedirectLocation] = useState('')

  const isMd = useBreakpoint('md')

  if (redirectLocation) {
    return <Redirect to={redirectLocation} push />
  }

  return (
    <div className={styles.dropdownWrapper}>
      <div
        className={classnames(styles.categorySelector, {
          [styles.categorySelectorLight]: light
        })}
        onClick={() => setCategorySelectorExpanded(true)}
      >
        <div className={styles.copy}>
          {dropdownNavigationItem ? dropdownNavigationItem.displayName : dropdownPlaceholder}
        </div>
        <DownArrow />
      </div>
      {categorySelectorExpanded && (
        <div className={styles.categorySelectorSheetHolder}>
          <CategorySelectorSheet
            light={light}
            className={styles.categorySheet}
            onRequestClose={() => setCategorySelectorExpanded(false)}
            onCategorySelected={(slug, displayName) => {
              const onboardingPath = generateCreateUrlFromCategory({
                maybeCategorySlug: slug,
                pathIntent: 'register',
                sourceKey
              })

              setDropdownNavigationItem({
                redirectLocation: onboardingPath,
                displayName
              })

              setCategorySelectorExpanded(false)
            }}
          />
        </div>
      )}
      <Button
        onClick={() => {
          dropdownNavigationItem && setRedirectLocation(dropdownNavigationItem.redirectLocation)
        }}
        className={styles.buttonLabel}
      >
        {isMd ? buttonText : 'GO'}
      </Button>
    </div>
  )
}

export default PathDropdown
